import {
  SUPERSET_CANVAS_CHART_DATA_EMPTY,
  SUPERSET_CANVAS_CHART_DATA_ERROR,
  SUPERSET_CANVAS_CHART_DATA_LOADING,
  SUPERSET_CANVAS_CHART_DATA_SUCCESS,
} from '../../../../../actionType';

// Keyed by cardId so many cards can load in parallel without
// clobbering one another.
const initialState = {
  byCard: {},
};

const setCard = (state, cardId, patch) => ({
  ...state,
  byCard: {
    ...state.byCard,
    [cardId]: { ...(state.byCard[cardId] || {}), ...patch },
  },
});

const SupersetCanvasChartData = (state = initialState, action) => {
  const cardId = action.payload?.cardId;

  switch (action.type) {
    case SUPERSET_CANVAS_CHART_DATA_LOADING:
      return setCard(state, cardId, { loading: true, error: false, message: null });

    case SUPERSET_CANVAS_CHART_DATA_SUCCESS:
      return setCard(state, cardId, { data: action.payload.data, loading: false, success: true, error: false, message: null });

    case SUPERSET_CANVAS_CHART_DATA_ERROR:
      return setCard(state, cardId, { data: null, loading: false, success: false, error: true, message: action.payload.message });

    case SUPERSET_CANVAS_CHART_DATA_EMPTY: {
      if (!cardId) return { ...initialState };
      const byCard = { ...state.byCard };
      delete byCard[cardId];
      return { ...state, byCard };
    }

    default:
      return state;
  }
};

export default SupersetCanvasChartData;
